export default (initialTab: string) => ({
  activeTab: initialTab,

  onTabChange(tab: string) {
    this.activeTab = tab

    this.$el.closest('[data-test="jumbotron"]')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })

    // The newly active carousel was initialized while hidden (x-show), so Embla measured
    // zero-width slides at init time and needs a reInit + explicit scrollTo once visible.
    this.$nextTick(() => {
      const carouselEl = this.$el.querySelector(`[x-ref="team-carousel-${tab}"]`) as HTMLElement | null

      if (!carouselEl) return

      const carousel = (window as any).Alpine.$data(carouselEl)

      carousel.reInit()
      carousel.scrollTo(1, true)
    })
  },
})
